import { http } from '../../config/axios'

export default function putResultadoMotorCreditoRegra(resultadoMotorCreditoRegra: any): Promise<string> {
  return http
    .put('api/resultadomotorcredito', resultadoMotorCreditoRegra)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro put resultado motor credito regra', error)
      throw Error(error.response.data)
    })
}
